const SAFE_INPUT_REGEX = /^[\w\s()\-_.,;'":+=?!*&%@#/\\]*$/;

export default SAFE_INPUT_REGEX;
